// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"5c34bea8","511":"36227783","659":"842929cd"}[chunkId] + ".chunk.js";
};